import React from "react";
import { FieldProps, getIn } from "formik";
import { TextField, TextFieldProps } from "./TextField";

type TextFieldAdapterProps = FieldProps<string> & TextFieldProps;

export const TextFieldAdapter: React.FC<TextFieldAdapterProps> = ({
	form,
	field,
	...textFieldProps
}) => {
	const touched = getIn(form.touched, field.name);
	const dirty = getIn(form.initialValues, field.name) !== field.value;
	const error = getIn(form.errors, field.name);

	return (
		<TextField
			{...field}
			{...textFieldProps}
			error={touched || dirty ? error : undefined}
		/>
	);
};
